/**
 * Legend (Phase 3, §6.4) — SPINE. An HTML legend rendered below the chart. Every
 * chart with ≥2 series shows this AND the ChartFrame table toggle, so a coloured
 * mark never carries meaning on colour alone.
 */

export type LegendShape = 'square' | 'line' | 'dot';

export interface LegendItem {
  label: string;
  color: string;
  shape?: LegendShape;
}

export interface LegendProps {
  items: LegendItem[];
  className?: string;
}

function Swatch({ color, shape }: { color: string; shape: LegendShape }) {
  if (shape === 'line') {
    return (
      <span
        aria-hidden
        className="inline-block h-0.5 w-4 shrink-0 rounded-full align-middle"
        style={{ backgroundColor: color }}
      />
    );
  }
  if (shape === 'dot') {
    return (
      <span
        aria-hidden
        className="inline-block h-2.5 w-2.5 shrink-0 rounded-full align-middle"
        style={{ backgroundColor: color }}
      />
    );
  }
  return (
    <span
      aria-hidden
      className="inline-block h-2.5 w-2.5 shrink-0 rounded-sm align-middle"
      style={{ backgroundColor: color }}
    />
  );
}

export function Legend({ items, className }: LegendProps) {
  if (items.length === 0) return null;
  return (
    <ul
      className={`flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-slate-600 dark:text-slate-400 ${className ?? ''}`}
    >
      {items.map((item, i) => (
        <li key={`${item.label}-${i}`} className="inline-flex items-center gap-1.5">
          <Swatch color={item.color} shape={item.shape ?? 'square'} />
          <span>{item.label}</span>
        </li>
      ))}
    </ul>
  );
}
